'use client'

import dynamic from 'next/dynamic'

const UserMenu = dynamic(async () => import('./UserMenu'), { ssr: false })

export default function () {
  return <UserMenu />
}
